module.exports = __webpack_public_path__ + "img/035.4f730aa3.jpg";